export const dateFormat = "DD.MM.YYYY";
export const formatTime = "HH:mm";
export const filterDateFormat = "DD.MM.YYYY";
export const filterDateFormatRequest = "YYYY-MM-DD";

export const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const codeRegexp = /^[\s+-]*([0-9][\s()+-]*){1,20}$/;
